import {IServiceFactory} from "../../../../service-factory.interface";
import {MealSsrBase} from "../meal-ssr-base";

//Meniu Pui la gratar cu sos de tomate, cartofi la cuptor si broccoli
export default class NbmlSsrType extends MealSsrBase {
    constructor(services: IServiceFactory) {
        super('NBML', services);
    }
}
